export function pluralize(n: number, singular: string, plural: string): string {
  return n > 1 ? `${n} ${plural}` : `${n} ${singular}`;
}
